export interface Partner {
  id: string;
  title: string;
  description: string;
  imageUrl: string;
  websiteUrl?: string;
  additionalLinks?: Array<{ label: string; url: string }>;
}

export const PARTNERS: Partner[] = [
  {
    id: 'seag',
    title: 'SEAG - Seguros de Alquiler',
    description:
      'SEAG es la compania lider en seguros de impago de alquiler en Espana. Como usuario de InversorHub, disfrutas de condiciones exclusivas: cobertura de vandalismo ampliada hasta 6.000 euros (en lugar de los 3.000 euros estandar). Protege tu inversion inmobiliaria con las mejores garantias del mercado.',
    imageUrl: '/images/logos/collaborations/seag_logo.jpeg',
    websiteUrl: 'https://www.seag.es/',
    additionalLinks: [
      {
        label: 'Garantia indefinida',
        url: 'https://www.seag.es/prestaciones-seguro-impago-alquiler/',
      },
      {
        label: 'Garantia de alquiler seguro de habitaciones',
        url: 'https://www.seag.es/garantia-de-alquiler-seguro-de-habitaciones/',
      },
      {
        label: 'Garantia temporal',
        url: 'https://www.seag.es/garantia-temporal-mejor-que-seguro-impago-alquiler/',
      },
      { label: 'Prestaciones adicionales', url: 'https://www.seag.es/prestaciones-adicionales/' },
    ],
  },
];
